export const path = {
  GET_LIMITS_FOR_THE_SERVICES: (nameOfService) =>
    `/MinandMaxAmountLimit/get/MinAndMaxAmountLimit/limit/${nameOfService}`,
  GET_USER_DETAILS: `/merchant/get/merchant/details`,
  BBPS_HELP: `/bbpsBillFetch/encryptSecondCall`,
  ACCOUNT_VERIFY: `/payOutDetails/verifyPayOutAccountNumber`,
  ACCOUNT_VERIFY_USERNAME: `/accountdata/verifyUsername`,
  SAVE_CONTACT_INFO: `/save/clientContact/info`,
  SAVE_PAYOUT_DATA: `/payOutDetails/save/createPayOutDetails`,
  // GET_ALL_PAYS : `/payOutDetails/get/getAllPayOutDetailsByMerchantid`,
  GET_ALL_PAYS: (nameOfService) =>
    `/payOutDetails/get/getAllPayOutDetailsByMerchantid/${nameOfService}`,
  GET_PAYOUT_TRANSACTIONS: `/transactions/get/payOutTransactions`,
  GET_WALLET_BALANCE: `/settlementMaintainence/get/settlementBalance`,
  GET_SERVICE: `/serviceTracking/get/serviceTracking`,
  GET_PAYOUT_CHARGES: `/digitalWallet/get/wallet/charges/BY/byDefaultScheme`,
  GET_LIMITS: `/MinandMaxAmountLimit/get/all/service/amountLimits`,
  GET_LIMITS_FOR_SERVICE: `/MinandMaxAmountLimit/get/MinAndMaxAmountLimit`,
  PAY_OUT_SERVICE: `/SettlementTransactions/save/settelement/transactions`,
  GET_TRANSACTIONS_ACCOUNTNO_LIMIT: `/transactions/getAccountNoAmountLimit`,
  GET_T1_AND_T2_TRANSACTIONS: `/unSettlementTransactions/get/upcoming/unSettled/amount`,
  // ACTIVE_SERVICE: `/serviceTracking/get/active/service/Tracking`,
  ACTIVE_ALL_SERVICES: `/serviceTracking/get/serviceTracking`,
  UPDATE_PAY_SERVICE_STATUS: `/payOutDetails/delete/basedOnAccount/serviceName`,
  STORE_BANK_DETAILS: `/merchant/updateMerchantBankDetails`,
  GET_ACCOUNT_STATUS: "/merchant/change/account/status",
  GET_PAYOUT_CHARGES_BY_WALLET_SCHEME: schemeName =>
    `/digitalWallet/get/All/walletCharges/By/${schemeName}`,

  // BBPS related Routes
  BBPS_BILL_INFO: "/bbpsBillFetch/encrypt",
  BBPS_PAY_INFO: (billId) => `/bbpsBillerInfo/getPayoption/${billId}`,
  BBPS_BILLFETCH_SECONDCALL: `/bbpsBillFetch/encryptSecondCall`,
  BBPS_GET_MINMAX_AMOUNT:
    "/MinandMaxAmountLimit/get/MinAndMaxAmountLimit/limit/ProMemberShip",
  BBPS_GET_SETTLEMENT_BALANCE:
    "/settlementMaintainence/get/leanAmount/totalAmount",
  BBPS_GET_WALLET_PAYOUT_CHARGES:
    "/digitalWallet/get/wallet/charges/BY/byDefaultScheme",
  VALIDATE_CARD_INSTANTPAY: `/rapidDetails/validateCardForInstantPay`,

  // Pan verify
  PAN_VERIFY: `/payments/panVerify/verify`,

  // Tickets
  CREATE_TICKET: `/tickets/newtickets`,
  GET_ALL_TICKETS: `/tickets/get/all/tickets`,

  // Pay U
  PAYU_INTEGRATION: `/payU/paymentIntegration`,

  // InstantPay
  INSTANTPAY_KYC_INTIATION: `/InstantpayCreditCardPayment/SignupEkycInitiate`,
  INSTANTPAY_KYC_OTP_VERIFICATION: `/InstantpayCreditCardPayment/instant-kyc-validate`,
  INSTANTPAY_BILLER_DETAILS: `/InstantpayCreditCardPayment/getBillerDetails`,
  INSTANTPAY_VALIDATE_BILL: `/InstantpayCreditCardPayment/validate-biller`,
  INSTANTPAY_BILL_ENQUIRY: `/InstantpayCreditCardPayment/bill-enquiry`,

  //Cashfree
  CREATE_CASHFREE_ORDER: `/payments/cashfree/cashFreePayment`,
  CASHFREE_STATUS_CHECK: (orderId) =>
    `/payments/cashFreePayment/paymentStatus/${orderId}`,
  CASHFREE_SEAMLESS: `/CashFreeSeamLess/createOrder`,
  CASHFREE_WEBVIEW: `/cashFreeWebView/create/order/cashfree/webView`,

  //Links
  GENRATE_PAY_LINK: `/pl/CustomLink`,
  PAYMENT_LINK_HISTORY: `/pl/get/allRecords`,

  //Refferal
  GET_REFERRAL_DATA: `/get/referral/amount`,

  //Optimiser
  PAYMENT_OPTIMISER: `/paymentOptimiser/get/paymentGateway/basedOn/percentage`,

  //CreditCardBillPayments
  // GET_CREDITCARDDETAILS:(MerchantId, mobileNumber) => `/creditCardDetails/get/creditCard/details/${MerchantId}/${mobileNumber}`,
  GET_CREDITCARDDETAILS: `/creditCardDetails/get/creditCard/details/byToken`,
  Update_CREDITCARDDETAILS: `/creditCardDetails/Update/deActivate/creditCardDetails/byMerchant`,
  ADD_CREDITCARDDETAILS: `/creditCardDetails/save/creditCardDetails`,
  VALIDATE_CREDIT_CARDNUMBER: `/rapidDetails/validate`,

  // Mobile Recharge
  fetchdetailswithNumber: `/RechargeService/FetchDetailswithId`,
  rechargeRequest: `/RechargeService/pay/recharge/amount`,

  // Get all Schemes
  GET_SCHEMEDETAILS_SCHEME_NAME: (schemeName) =>
    `/scheme/getSchemeDetailsByScheme/${schemeName}`,

  //user Image
  GET_USER_IMAGE: (id) => `/UserImages/getuserimage/${id}`,

  //zaakPay
  UPI_COLLECT_VERIFY: `/ZaakpayIntegration/Zaakpaycollectverification`,
  UPI_COLLECT_STATUS: `/ZaakpayIntegration/Zaakpaycollectverification/polling`,

  // chat and help
  GET_MESSAGES_OF_TRANSACTION: (merId, mobileNum, transId) =>
    `/QueryMessage/SendMessagesToFrontend/${merId}/${mobileNum}/${transId}`,
  SAVE_MESSAGES_OF_TRANSACTION: (merId, mobileNum, transId) =>
    `/QueryMessage/saveMessageFromFrontend/${merId}/${mobileNum}/${transId}`,

  // phonepe
  GET_PHONEPE_ORDERID: `/phonepeIntegration/generate/orderId`,
};
